<template>
  <div class="container">
    <div v-if="!from" class="up">
      <template v-for="(v, k) in detail.mtms">
        <div class="self" v-show="detail.is_need_send_back">
          <template v-if="!detail.self_send">
            <p class="tip">
              *您选择自己提供物料，请详细填写您所提供的物料信息，以便后期核对，并将相关物料根据下方收货地址邮寄给厂家
            </p>
            <div class="table">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>面料信息</th>
                    <th>幅宽/克重</th>
                    <th>成分</th>
                    <th>使用说明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in v.design_data.category
                      .material_self"
                    :key="index"
                  >
                    <td>{{ item.alias }}</td>
                    <td>
                      <div class="material-info">
                        <img :src="item.image" alt="" class="image" />
                        <div class="name">{{ item.fabric_name_cn }}</div>
                      </div>
                    </td>
                    <td>{{ item.width_wide }}</td>
                    <td>{{ item.component }}</td>
                    <td>{{ item.desc }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>辅料信息</th>
                  <th>单位</th>
                  <th>数量</th>
                  <th>使用说明</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in v.design_data.category.accessory_self"
                  :key="index"
                >
                  <td>{{ item.alias }}</td>
                  <td>
                    <div class="material-info">
                      <img :src="item.image" alt="" class="image" />
                      <div class="name">{{ item.accessory_name }}</div>
                    </div>
                  </td>
                  <td>{{ item.measure_unit }}</td>
                  <td>{{ item.num }}</td>
                  <td>{{ item.desc }}</td>
                </tr>
              </tbody>
            </table>
            <div class="tip2">
              <div class="btn-print" @click="go2fabric">打印物料单详情</div>
            </div>
            <div class="back-info">
              <div class="left">
                <p>收件人：{{ setting.contact_person }}</p>
                <p>电话：{{ setting.contact_mobile }}</p>
                <p>收货地址：{{ setting.contact_address }}</p>
              </div>
              <div class="btn-fill" @click="go2fill">填写寄货物流单号</div>
            </div>
          </template>
          <template v-else>
            <div
              class="back-info"
              style="
                background: white;
                border: 1px solid #e2e5e9;
                justify-content: flex-start;
                align-items: flex-start;
                height: auto;
                padding: 20px 30px;
              "
            >
              <img
                src="../../assets/images/pay-success.png"
                alt=""
                class="icon"
              />
              <div class="left" style="border: none">
                <p v-if="detail.self_send">已寄出，物流单创建成功</p>
                <p v-else>物料已确认签收</p>
                <div class="success-logistics-list">
                  <div v-for="(item, i) in detail.ops" :key="'sli'+i" class="success-logistics-item">
                      <span>{{i+1}}. 物流公司：{{item.logistics_name||'-'}}</span>
                      <span>快递单号：{{item.logistics_no||'-'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <popup
      :show.sync="is_popup_show"
      width="650px"
      height="auto"
      @on-close="close"
    >
      <h2>填写物流单号</h2>
      <div class="form" style="max-height:520px;overflow-y:auto;">
        <div class="form-group form-group-row" v-for="(item, index) in form_data.list" :key="index">
          <div class="form-label">快递名称：</div>
          <div class="form-control">
            <select
              class="input input-sm"
              placeholder="请输入快递名称"
              v-model="item.logistics_name"
              :disabled="item.is_entry"
            >
              <option
                v-for="(v, k) in logistics"
                :key="k"
                :value="v"
              >
                {{ v }}
              </option>
            </select>
          </div>
          <div class="form-label">快递单号：</div>
          <div class="form-control">
            <input
              type="text"
              class="input input-sm"
              placeholder="请输入快递单号"
              v-model="item.logistics_no"
              :readonly="item.is_entry"
            />
          </div>
          <div v-if="form_data.list.length > 1 && !item.is_entry" class="btn-delete" @click="removeLogistics(index)">删除</div>
        </div>
        <div class="btn-add" @click="addLogistics">+ 添加物流</div>
        <div class="btn-submit" @click="save">保存</div>
      </div>
    </popup>

    <div class="bottom">
      <div class="info">
        <div class="left">
          <h3 class="title">订单详情</h3>
          <div class="item">
            <div class="label">订单号：</div>
            <div class="text">{{ detail.order_no }}</div>
          </div>
          <div class="item">
            <div class="label">下单时间：</div>
            <div class="text">{{ detail.submit_time }}</div>
          </div>
          <div class="item">
            <div class="label">要求发货时间：</div>
            <div class="text">{{ detail.date_required }}</div>
          </div>
          <div class="item">
            <div class="label">收货信息：</div>
            <div class="text">
              {{ detail.contact_person }}，{{ detail.contact_mobile }}，{{
                detail.province
              }}{{ detail.city }}{{ detail.zone }}{{ detail.address }}
            </div>
          </div>
          <div class="item" v-if="detail.need_sample > 0">
            <div class="label">面料寄样：</div>
            <div class="text">
              需要寄样 <span @click="show_sample_detail = true">查看详情</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">
            订单状态：<span class="status" :class="oc(detail)">{{
              detail.status_name
            }}</span>
          </div>
          <div class="item">
            <div class="label">订单金额：</div>
            <div class="text">
              <span class="money">￥{{ detail.total_price }}</span
              >（含运费￥0）
            </div>
          </div>
          <template v-if="detail.is_yx_confirm">
            <div class="item">
              <div class="label">工艺实样物流：</div>
              <div class="text">
                {{ detail.yx_logistics_company }}，{{ detail.yx_logistics_no }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="margin-top-20" v-if="detail.logistics_no">
        <LogisticsTracking :trackingList="trackingList" :logistics_name="detail.logistics_company" :logistics_no="detail.logistics_no"></LogisticsTracking>
      </div>
      <table border="1" style="margin-top: 30px">
        <thead>
          <tr>
            <th>产品信息</th>
            <th v-if="!from">款式分类</th>
            <th>尺码</th>
            <th>数量</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!from">
            <tr v-for="(v, k) in detail.mtms" :key="k">
              <td>
                <div class="product-info cursor" @click="go2summary(v.id)">
                  <img
                    :src="v.design_data.category.image"
                    alt=""
                    class="image"
                  />
                  <div class="product-name">{{ v.style_name }}</div>
                </div>
              </td>
              <td>{{ v.design_data.category.product_category_name }}</td>
              <td>{{ v.spec_info.join(";") }}</td>
              <td>x{{ v.quantity }}</td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="(v, k) in detail.goods" :key="`mall-${k}`">
              <td>
                <!--  @click="go2summary(v.id)" -->
                <div class="product-info cursor">
                  <img :src="v.product_image" alt="" class="image" />
                  <div class="product-name">{{ v.product_name }}</div>
                </div>
              </td>
              <!-- <td></td> -->
              <!-- <td>{{ v.design_data.category.product_category_name }}</td> -->
              <td>{{ v.spec_info || "" }}</td>
              <td>x{{ v.quantity }}</td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="price-wrap">
        <div class="item" v-for="(vv, kk) in detail.cost_list">
          <div class="label">{{ vv.title }}</div>
          <div class="text">￥{{ vv.amount|price_format }}</div>
        </div>
        <div class="item">
          <div class="label">实付：</div>
          <div class="text">
            <span class="money">￥{{ detail.total_price }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 寄样详情单 -->
    <Popup :show.sync="show_sample_detail" width="998px" height="750px">
      <div class="sample">
        <div class="sample-title">寄样详情单</div>
        <table>
          <thead>
            <tr>
              <!-- <th></th> -->
              <th>产品信息</th>
              <th>颜色</th>
              <th>成分</th>
              <th>幅宽/克重</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in detail.order_material">
              <tr class="tr-no-td">
                <td colspan="4">
                  <div class="logistics">
                    <div class="company-no">
                      <div v-for="(no, ni) in (item[0].logistics_no||'').split(',')" :key="'lcdiv'+ni">
                        <span>物流信息:{{ ((item[0].logistics_name||'').split(',')[ni]) || '暂无物流信息,请耐心等待' }}</span>
                        <span>快递单号:{{ no }}</span>
                        <span class="btn" @click="onCopyLogistics(no)">复制单号</span>
                      </div>
                    </div>
                    <!-- <div v-if="item[0].logistics_name && item[0].logistics_no" class="logistics-time">发货时间:{{item[0].create_time}}</div> -->
                  </div>
                </td>
              </tr>
              <tr class="tr-td" v-for="val in item" :key="`vi${val.id}`">
                <!-- <td>面料A</td> -->
                <td>
                  <div class="main-info">
                    <img
                      :src="val.fabric_image | default_img"
                      alt=""
                      class="images"
                    />
                    <div class="name-code">
                      <span>名称:{{ val.fabric_name }}</span>
                      <span>编码:{{ val.fabric_key }}</span>
                    </div>
                  </div>
                </td>
                <td>{{ val.color_name }}</td>
                <td>{{ val.fabric.component }}</td>
                <td>
                  {{ val.fabric.width_wide }} <br />
                  {{ val.fabric.weight }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </Popup>
  </div>
</template>

<script>
import {
  GetLogisticsTracking,
  MallOrderDetail,
  OrderDetail,
  Profile,
  SendFabric,
} from "@/api/index.js";
import LogisticsTracking from "@/components/LogisticsTracking.vue";
import Popup from "@/components/Popup.vue";

import logistics from "@/utils/logistics";
import { mapState } from "vuex";
export default {
  name: "OrderDetail",
  components: {
    Popup,
    LogisticsTracking,
  },
  data() {
    return {
      uuid: 0,
      detail: {
        cost: [],
        spec_info: [],
        design: {},
      },
      is_popup_show: false,
      form_data: {
        logistics_name: "",
        logistics_no: "",
        list: [{ logistics_name: "", logistics_no: "", is_entry: false }],
      },
      show_sample_detail: false,
      from: "",
      logistics,
      trackingList: {},
    };
  },
  watch: {},
  computed: {
    ...mapState(["setting"]),
  },
  mounted() {
    const { uuid, from } = this.$route.query;
    this.uuid = uuid;
    if (from && from === "mall") {
      this.from = from;
      this.onGetMallOrderDetail();
    } else {
      this.getDetail();
    }
  },
  methods: {
    async onGetMallOrderDetail() {
      try {
        const { code, msg, data } = await MallOrderDetail({ uuid: this.uuid });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        this.detail = data;
        this.getTracking()
      } catch (e) {
        console.log("err-mall-order-detail", e);
      }
    },
    async getTracking() {
      if (!this.detail.logistics_no) {
        return;
      }
      try {
        const { code, msg, data } = await GetLogisticsTracking({
          logistics_no: this.detail.logistics_no,
          logistics_name: this.detail.logistics_company,
          phone: this.detail.contact_mobile,
        });
        this.trackingList = data.data;
      } catch (e) {
        console.log("err-mall-order-detail", e);
      }
    },
    go2summary(id) {
      let route = this.$router.resolve({
        name: "WorkBenchSummaryOuter",
        query: { uuid: id, from: "detail" },
      });
      window.open(route.href, "_blank");
    },
    async onCopyLogistics(logistics_no) {
      if (!logistics_no) return;
      await navigator.clipboard.writeText(logistics_no);
      this.$layer.msg("复制成功");
    },
    close() {
      this.form_data = { logistics_name: "", logistics_no: "", list: [{ logistics_name: "", logistics_no: "", is_entry: false }] };
    },
    save() {
      this.form_data.logistics_name = this.form_data.list.map(i => i.logistics_name).join(',');
      this.form_data.logistics_no = this.form_data.list.map(i => i.logistics_no).join(',');
      SendFabric({ ...this.form_data, uuid: this.detail.uuid })
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.is_popup_show = false;
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          this.getDetail();
        });
    },
    addLogistics() {
      this.form_data.list.push({ logistics_name: '', logistics_no: '', is_entry: false });
    },
    removeLogistics(index) {
      if (this.form_data.list.length > 1 && !this.form_data.list[index].is_entry) {
        this.form_data.list.splice(index, 1);
      }
    },
    go2fill() {
      const ops = this.detail.ops || [];
      if (Array.isArray(ops) && ops.length > 0) {
        this.form_data.list = ops.map(item => ({
          logistics_name: item.logistics_name || '',
          logistics_no: item.logistics_no || '',
          is_entry: item.is_entry == 1
        }));
      } else {
        this.form_data.list = [{ logistics_name: '', logistics_no: '', is_entry: false }];
      }
      this.is_popup_show = true;
    },
    go2fabric() {
      this.$router.push({
        name: "FabricDetail",
        query: { uuid: this.detail.uuid },
      });
    },
    oc(v) {
      return [v.status_text];
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getDetail() {
      return OrderDetail({ uuid: this.uuid })
        .then((response) => {
          this.detail = response.data;
          this.getTracking()
        })
        .catch((err) => {
          this.$layer.msg(err.msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 30px;
  padding: 0 70px 100px 30px;
  background: #f6f7fa;

  .up {
    padding: 36px 0;
    border-radius: 10px;
    background: white;
    display: flex;
    flex-wrap: wrap;

    .self {
      padding: 0 20px;
      width: 100%;
      .tip {
        font-size: 18px;
        color: #1a1a1a;
        font-weight: bold;
        padding: 0px 0 20px 0;
      }
      .tip2 {
        margin: 12px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tt {
          font-size: 14px;
          color: #666666;
        }
        .btn-print {
          width: 141px;
          height: 37px;
          line-height: 37px;
          background: white;
          border-radius: 18px;
          border: 1px solid #fa3d5a;
          color: #fa3d5a;
          text-align: center;
          cursor: pointer;
        }
      }
      .back-info {
        background: #f7f7f7;
        height: 150px;
        margin: 12px 0;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #4d4d4d;
        font-size: 16px;
        .btn-fill {
          width: 180px;
          height: 45px;
          line-height: 45px;
          background: #fa3d5a;
          border-radius: 5px 5px 5px 5px;
          color: white;
          text-align: center;
          cursor: pointer;
        }
        .icon {
          width: 44px;
          height: 44px;
          margin: 0 20px;
          flex-shrink: 0;
        }
        .success-logistics-list {
          margin-top: 8px;
          .success-logistics-item {
            display: flex;
            gap: 24px;
            padding: 8px 12px;
            margin-top: 6px;
            background: #f5f5f5;
            border-radius: 4px;
            font-size: 13px;
            color: #4d4d4d;
            span {
              white-space: nowrap;
            }
          }
        }
      }
      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        table-layout: auto;
        border: 1px solid #e5e5e5;
        text-align: center;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        margin-bottom: 20px;
        .material-info {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .image {
            width: 68px;
            height: 68px;
            object-fit: contain;
          }
          .product-name {
            color: #191a1c;
            font-size: 14px;
            font-weight: 500;
          }
        }
        thead {
          background: #f6f7fa;
          line-height: 52px;
        }
        th,
        td {
          padding: 8px;
          border: 1px solid #e5e5e5;
        }
        th:first-child,
        td:first-child {
          padding: 10px;
          width: 100px;
        }
        th:nth-child(2),
        td:nth-child(2) {
          width: 400px;
        }
        th:nth-child(3),
        td:nth-child(3) {
          width: 100px;
        }
        th:nth-child(4),
        td:nth-child(4) {
          width: 200px;
        }

        td:last-child,
        th:last-child {
          width: 300px;
        }
      }
    }
  }

  .bottom {
    margin-top: 10px;
    padding: 36px 30px;
    border-radius: 10px;
    background: white;
    .info {
      display: flex;
      margin-bottom: 20px;
      .left {
        padding-left: 30px;
        width: 670px;
        border-right: 1px solid #e6e6e6;
        .title {
          color: #333333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 30px;
        }
        .item {
          margin: 10px 0;
          font-size: 12px;
          display: flex;
          flex-wrap: nowrap;
          .label {
            width: 100px;
            color: #191a1c;
            text-align: right;
          }
          .text {
            color: #666666;
            span {
              color: #5e8fc7;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
      .right {
        width: 600px;
        padding-left: 30px;
        .title {
          color: #333333;
          font-size: 16px;
          margin-bottom: 25px;
          .status {
            font-size: 20px;
            font-weight: bold;
            &.unpaid {
              color: #ff4400;
            }
            &.wait_delivery {
              color: #1572b8;
            }
            &.wait_confirm {
              color: #32a410;
            }
            &.cancel {
              color: #666666;
            }
            &.complete {
              color: #666666;
            }
          }
        }
        .item {
          margin: 10px 0;
          font-size: 12px;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          .label {
            width: 100px;
            color: #191a1c;
          }
          .text {
            color: #666666;
            .money {
              font-weight: bold;
              font-size: 16px;
            }
          }
        }
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      table-layout: fixed;
      border: 1px solid #e5e5e5;
      text-align: center;
      table-layout: fixed;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .product-info {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .image {
          width: 68px;
          height: 68px;
        }
        .product-name {
          color: #191a1c;
          font-size: 14px;
          font-weight: 500;
        }
      }
      thead {
        background: #f6f7fa;
        line-height: 52px;
      }
      th,
      td {
        padding: 8px;
        border: 1px solid #e5e5e5;
      }
      th:first-child,
      td:first-child {
        padding: 10px;
        max-width: 500px;
      }
      th:last-child,
      td:last-child {
        width: 150px;
      }
      td:nth-child(2),
      th:nth-child(2) {
        width: 150px;
      }
      td:nth-child(4),
      th:nth-child(4) {
        width: 150px;
      }
    }

    .price-wrap {
      margin-top: 70px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin: 10px 0;
        font-size: 14px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        color: #191a1c;
        .label {
          width: 130px;
          text-align: right;
        }
        .text {
          color: #666666;
          .money {
            font-weight: bold;
            font-size: 16px;
            color: #fa3d5a;
          }
        }
      }
    }
  }
}

::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      &.form-group-row {
        flex-wrap: nowrap;
      }
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        flex-shrink: 0;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly], &[disabled] {
            background: #f5f5f5;
            color: #999;
            cursor: not-allowed;
          }
          &.input-sm {
            width: 180px;
          }
          &:nth-of-type(2) .input-sm {
            width: 220px;
          }
        }
      }
    }

    .btn-add {
      margin: 15px 0 0 100px;
      width: 110px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      color: #666;
      font-size: 13px;
    }
    .btn-delete {
      position: static;
      margin-left: 10px;
      flex-shrink: 0;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fa3d5a;
      cursor: pointer;
      font-size: 13px;
      border: 1px solid #fa3d5a;
      border-radius: 4px;
    }
    .btn-submit {
      margin: 40px auto 0;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .sample {
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    max-height: 700px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .sample-title {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      text-align: center;
      margin-top: 39px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin-top: 26px;
      border: none !important;
      text-align: center;
      thead {
        background: #333333;
        color: #ffffff;
        font-weight: bold;
        font-size: 14px;
        height: 50px;
        th {
          border: 1px solid #cccccc;
        }
      }
      tbody {
        border: none !important;
        .tr-no-td {
          background: #efefef;
          width: 100%;
          height: 44px;
          margin-top: 18px !important;
          border: 1px solid #cccccc;
          td {
            padding: 0 20px;
            .logistics {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              .company-no {
                display: flex;
                align-items: center;
                column-gap: 17px;
                .btn {
                  color: #fa3d5a;
                  cursor: pointer;
                }
              }
              .logistics-time {
                color: #666666;
              }
            }
          }
        }
        .tr-td {
          height: 91px;
        }
        td {
          border: 1px solid #cccccc;
          padding: 10px;
        }
        .main-info {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .images {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            border: 1px solid #e3e4e6;
          }
          .name-code {
            display: flex;
            flex-direction: column;
            text-align: left;
          }
        }
      }
      th:first-child,
      td:first-child {
        // width:91px;
        width: 300px;
      }
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3) {
        width: 160px;
      }
      th:last-child,
      td:last-child {
        width: 130px;
      }
    }
  }
}
</style>
